var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-screen vx-row no-gutter items-center justify-center authorization_background",attrs:{"id":"logo_image_background"}},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }